export const MASONRY_NAMESPACE_CHAT_HISTORY = 'chatHistory' as const;

export const CHAT_HISTORY_ROOT_NODE_IDS = {
  chatHistoryPageRootNodeId: 'core$chatHistory$landingPage$root',
} as const;

export const NODE_TYPE_CHAT_HISTORY_CONTAINER = 'chatHistoryContainer';
export const NODE_TYPE_CHAT_HISTORY_MESSAGE = 'chatHistoryMessage';
